import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const SalarySettings = () => {
  const [rows, setRows] = useState([
    { id: 1, from: "", to: "", percent: "" },
  ]);

  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  const addRow = () => {
    setRows((prev) => [
      ...prev,
      { id: Date.now(), from: "", to: "", percent: "" },
    ]);
  };

  const removeRow = (id) => {
    setRows((prev) => prev.filter((row) => row.id !== id));
  };

  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Salary Settings
      </motion.h5>

      {/* TOP CARDS */}
      <div className="row g-3">
        {["DA & HRA", "Provident Fund", "ESI"].map((title, i) => (
          <div className="col-md-4" key={i}>
            <motion.div
              className="card shadow-sm border-0 h-100"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ scale: 1.02 }}
            >
              <div className="card-header bg-white fw-semibold d-flex justify-content-between">
                {title}
                <span className="text-muted">⚙️</span>
              </div>

              <div className="card-body">
                <input
                  className="form-control mb-2"
                  placeholder={
                    title === "DA & HRA"
                      ? "DA (%)"
                      : "Employee Share (%)"
                  }
                />
                <input
                  className="form-control"
                  placeholder={
                    title === "DA & HRA"
                      ? "HRA (%)"
                      : "Organization Share (%)"
                  }
                />
              </div>
            </motion.div>
          </div>
        ))}
      </div>

      {/* TDS SECTION */}
      <motion.div
        className="card shadow-sm border-0 mt-4"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
      >
        <div className="card-header bg-white d-flex justify-content-between">
          <span className="fw-semibold">TDS Annual Salary</span>

          <motion.button
            whileTap={{ scale: 0.85 }}
            className="btn btn-outline-primary btn-sm"
            onClick={addRow}
          >
            + Add
          </motion.button>
        </div>

        <div className="card-body">
          <AnimatePresence>
            {rows.map((row, index) => (
              <motion.div
                key={row.id}
                className="row g-2 mb-2 align-items-center"
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -15 }}
                transition={{ delay: index * 0.05 }}
                whileHover={{ scale: 1.01 }}
              >
                <div className="col-md-4">
                  <input
                    className="form-control"
                    placeholder="Salary From"
                    value={row.from}
                    onChange={(e) =>
                      handleChange(index, "from", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-4">
                  <input
                    className="form-control"
                    placeholder="Salary To"
                    value={row.to}
                    onChange={(e) =>
                      handleChange(index, "to", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-3">
                  <input
                    className="form-control"
                    placeholder="%"
                    value={row.percent}
                    onChange={(e) =>
                      handleChange(index, "percent", e.target.value)
                    }
                  />
                </div>

                <div className="col-md-1">
                  {rows.length > 1 && (
                    <motion.button
                      whileTap={{ scale: 0.8 }}
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => removeRow(row.id)}
                    >
                      ×
                    </motion.button>
                  )}
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </motion.div>

      {/* FOOTER */}
      <motion.div
        className="d-flex justify-content-end gap-2 mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-secondary"
        >
          Cancel
        </motion.button>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-success"
        >
          Save Changes
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default SalarySettings;